import { useRef } from "react";
import { useTheme } from "../../../theme";

export default function ParticleField() {
  const t = useTheme();
  const particles = useRef(
    Array.from({ length: 30 }, () => ({
      x: Math.random() * 100, y: Math.random() * 100,
      size: Math.random() * 3 + 1, opacity: Math.random() * 0.3 + 0.05,
      duration: Math.random() * 20 + 15, delay: Math.random() * -20,
    }))
  ).current;

  return (
    <div style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0 }}>
      {particles.map((p, i) => (
        <div key={i} style={{
          position: "absolute", left: `${p.x}%`, top: `${p.y}%`,
          width: p.size, height: p.size, borderRadius: "50%",
          background: t.particleColor, opacity: p.opacity,
          animation: `float ${p.duration}s ease-in-out ${p.delay}s infinite alternate`,
        }} />
      ))}
    </div>
  );
}

